import React from 'react';
import styled from '@emotion/styled';
import { LockKey } from 'phosphor-react';
import { Text } from '../..';
import { ThemeProps } from '../../../types';

export interface SecureFooterProps {
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;
}

const SecureFooter = ({ className }: SecureFooterProps) => {
  return (
    <footer className={className}>
      <LockKey size={18} />
      <Text element='small'>{'Secure Payment'}</Text>
    </footer>
  );
};

const StyledSecureFooter = styled((props: any) => <SecureFooter {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.common.grey,
    bottom: 0,
    flexDirection: 'row',
    display: 'flex',
    justifyContent: 'center',
    left: 0,
    paddingBottom: 12,
    paddingTop: 12,
    position: 'absolute',
    right: 0,
    svg: {
      marginRight: 6,
    },
  })}
`;

export default StyledSecureFooter;
